import { AfterViewInit, Component, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatError, MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { LoginService } from '../../../core/services/Login/login.service';
import { Router } from '@angular/router';
import { CustomErrorStateMatcher } from '../../../core/models/CustomErrorStateMatcher';
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';
import { ResponseVm } from '../../../core/models/response-vm';
import { LoginHeaderComponent } from '../../../shared/components/login-header/login-header.component';
import { FooterComponent } from '../../../shared/components/app-footer/footer.component';
import { MatButtonModule } from '@angular/material/button';
import { LoadingService } from '../../../core/services/shared-services/loading.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule,
    MatLabel,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatFormFieldModule,
    MatInputModule,
    MatError,
    MatButtonModule,
    LoginHeaderComponent,
    MatProgressSpinner,
    FooterComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
   private loader = inject(LoadingService);
    loading$ = this.loader.loading$;
  private router = inject(Router);
  loginService = inject(LoginService);
  localStorage = inject(AesEncDecService);
  matcher = new CustomErrorStateMatcher();

  loginFailedMessage: string;
  loginForm: FormGroup;
  formValues: any;
  captchaForm: FormGroup;
  captchaText: string;
  captchaImage: string;
  error_messages = {
    'userId': [
      { type: 'required', message: 'UserID is required.' }
    ],
    'password': [
      { type: 'required', message: 'password is required.' },
      { type: 'minlength', message: 'Password must be at least 10 characters long.' },
      { type: 'maxlength', message: 'Password cannot be more than 30 characters long.' }
    ],
  }
  constructor(private fb: FormBuilder) {
    this.loginForm = this.fb.group({
      userId: new FormControl('', Validators.compose([
        Validators.required
      ])),
      password: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(30)
      ])),
    })
    this.captchaForm = this.fb.group({
      captchaInput: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    localStorage.clear();
    this.generateCaptcha();
  }

  generateCaptcha(): void {
    this.captchaText = this.generateRandomString(6);
    this.captchaImage = this.createCaptchaImage(this.captchaText);
  }

  generateRandomString(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  createCaptchaImage(text: string): string {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 150;
    canvas.height = 50;

    if (ctx) {
      ctx.fillStyle = '#f2f2f2';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = '30px Arial';
      ctx.fillStyle = '#000';
      ctx.fillText(text, 10, 35);
    }

    return canvas.toDataURL('image/png');
  }
  receiveFormValues(values: any): void {
    this.formValues = values;
  }

  onSubmit() {
    if (this.captchaForm.value.captchaInput === this.captchaText) {

      this.formValues = this.loginForm.value;
      this.loginService.login(this.formValues).subscribe({
        next: (response: ResponseVm) => {
          if (response.loginDetails != null) {
            console.log(response.loginDetails);
            localStorage.clear();
            this.localStorage.saveData("loginDetails", JSON.stringify(response.loginDetails));
            this.router.navigateByUrl('landing');
          }
          else {
            this.loginFailedMessage = response.responseMessage;
          }
        },
        error: error => {
          this.loginFailedMessage = error.error.ResponseMessage;
          console.error('There was an error!', error);
        }
      });
    }

    else {
      this.loginFailedMessage = 'CAPTCHA verification failed. Please try again.';
      this.generateCaptcha();
    }
  }
  onForgotPassword(): void {
    this.router.navigateByUrl('forgot-password');
  }
}